import React from 'react';
import { Modal, Box, Grid, Typography, Button } from '@mui/material';
import { ReactComponent as IconInfo } from '../../../assets/images/svg/utils/info.svg';
import useStyles from '../../../assets/styles/pages/ShopRequest';

interface Props {
  open: boolean;
  onClose: () => void;
  title: string;
  description: string;
  icon?: React.ElementType;
  primaryText: string;
  primaryAction: () => void;
  secondaryText?: string;
  secondaryAction?: () => void;
}

const styleModalBottom = {
  position: 'absolute' as const,
  bottom: 0,
  width: '100%',
  maxWidth: 680,
  borderRadius: '32px 32px 0px 0px',
  p: '20px 20px 10px 20px',
  bgcolor: 'background.paper',
  outline: 'none',
};

export const ModalMessage = ({
  open,
  onClose,
  title,
  description,
  icon: Icon = IconInfo,
  primaryText,
  primaryAction,
  secondaryText,
  secondaryAction,
}: Props): JSX.Element => {
  const classeStyle = useStyles();

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={styleModalBottom}>
        <Grid container item xs={12} justifyContent="center">
          <Icon className={classeStyle.iconModal} />
        </Grid>

        <Grid container item xs={12} justifyContent="center">
          <Typography
            variant="h6"
            component="h2"
            className={classeStyle.titleModal}
            style={{ fontWeight: '550', width: '100%', textAlign: 'center' }}
          >
            {title}
          </Typography>

          <Typography sx={{ mt: 2 }} className={classeStyle.textModal}>
            {description}
          </Typography>
        </Grid>

        <Grid container item xs={12} justifyContent="center">
          <Button
            className={classeStyle.btnSubmit}
            style={{ width: '80%' }}
            onClick={() => {
              primaryAction();
              onClose();
            }}
            variant="contained"
          >
            {primaryText}
          </Button>
        </Grid>

        {secondaryText && (
          <Grid container item xs={12} justifyContent="center">
            <Button
              variant="text"
              onClick={() => {
                if (secondaryAction) secondaryAction();
                onClose();
              }}
            >
              <p className={classeStyle.textBtnKeepShopping}>{secondaryText}</p>
            </Button>
          </Grid>
        )}
      </Box>
    </Modal>
  );
};
